export const footer = {
  it: {
    contact: {
      title: "Contatti",
      email: "victor@victorlazari.com",
      phone: "+39 380 633 1704",
      address: "San Pietro in Vinoli, Ravenna, 48125, Italia",
      piva: "P.IVA 02643270396"
    },
    quickLinks: {
      title: "Link Rapidi",
      home: "Home",
      blog: "Blog",
      testimonials: "Testimonianze",
      contact: "Contatti"
    },
    services: {
      title: "Servizi",
      ai: "App gestionali (Power Apps)",
      automation: "Automazione processi",
      development: "Dashboard Power BI",
      consulting: "Integrazioni e dati"
    },
    legal: {
      title: "Legale",
      privacy: "Privacy",
      terms: "Termini di Servizio",
      cookies: "Cookies"
    },
    rights: "Tutti i diritti riservati",
    copyright: "© {{year}} Victor Lazari — P.IVA 02643270396. Tutti i diritti riservati"
  },
  en: {
    contact: {
      title: "Contact",
      email: "victor@victorlazari.com",
      phone: "+39 380 633 1704",
      address: "San Pietro in Vinoli, Ravenna, 48125, Italy",
      piva: "VAT IT02643270396"
    },
    quickLinks: {
      title: "Quick Links",
      home: "Home",
      blog: "Blog",
      testimonials: "Testimonials",
      contact: "Contact"
    },
    services: {
      title: "Services",
      ai: "Business apps (Power Apps)",
      automation: "Process automation",
      development: "Power BI dashboards",
      consulting: "Integrations & data"
    },
    legal: {
      title: "Legal",
      privacy: "Privacy",
      terms: "Terms of Service",
      cookies: "Cookies"
    },
    rights: "All rights reserved",
    copyright: "© {{year}} Victor Lazari — VAT IT02643270396. All rights reserved"
  }
};